import type { ReactNode } from 'react'
import { apiAssetUrl } from '../../config'

export type TeamRow = {
  id: number
  name: string
  title: string | null
  bio?: string | null
  linkedin_url?: string | null
  photo_path?: string | null
  photo_stored_path?: string | null
  is_active: number
  sort_order: number
}

export type TeamDetail = TeamRow

export function StatusBadge({ active }: { active: boolean }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[0.7rem] font-bold uppercase tracking-wide ${
        active ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-100 text-slate-600'
      }`}
    >
      {active ? 'Active' : 'Hidden'}
    </span>
  )
}

export function PhotoThumb({ path, name }: { path?: string | null; name?: string }) {
  if (!path) {
    const initials = (name || '?')
      .split(/\s+/)
      .map((p) => p[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase()
    return (
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary/10 border border-primary/10 text-xs font-bold text-primary">
        {initials || '?'}
      </div>
    )
  }
  return (
    <img
      src={apiAssetUrl(path)}
      alt=""
      className="h-11 w-11 shrink-0 rounded-full object-cover border border-primary/10 bg-slate-100"
    />
  )
}

export function IconAction({
  children,
  label,
  onClick,
  danger,
}: {
  children: ReactNode
  label: string
  onClick: () => void
  danger?: boolean
}) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      onClick={onClick}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-xl border transition active:scale-95 ${
        danger
          ? 'border-red-200 bg-red-50 text-red-600 hover:bg-red-100'
          : 'border-primary/15 bg-white text-primary hover:bg-primary/[0.06]'
      }`}
    >
      {children}
    </button>
  )
}
